import { Box, type SxProps, type Theme } from '@mui/material';
import { forwardRef, type ReactNode } from 'react';

interface ToolPropertiesTrayProps {
    children: ReactNode;
    sx?: SxProps<Theme>;
}

/**
 * Floating properties bar that renders below a toolbar.
 * Rendered as an absolutely-positioned element relative to the
 * toolbar's parent, appearing as a separate glassmorphic bar.
 */
const ToolPropertiesTray = forwardRef<HTMLDivElement, ToolPropertiesTrayProps>(
    function ToolPropertiesTray({ children, sx: sxOverrides, ...rest }, ref) {
        return (
            <Box
                ref={ref}
                {...rest}
                sx={[
                    (theme) => ({
                        position: 'absolute',
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        mt: 1,
                        display: 'flex',
                        alignItems: 'center',
                        px: 1,
                        py: '3px',
                        borderRadius: 100,
                        ...theme.mixins.glassOverlay,
                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.27)',
                        border: '1px solid rgba(0, 0, 0, 0.1)',
                        pointerEvents: 'auto',
                        whiteSpace: 'nowrap',
                    }),
                    ...(Array.isArray(sxOverrides)
                        ? sxOverrides
                        : sxOverrides
                          ? [sxOverrides]
                          : []),
                ]}
            >
                {children}
            </Box>
        );
    }
);

export default ToolPropertiesTray;
